import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAhrefsPageview } from '../utils/analytics';

/**
 * Sends one Ahrefs Web Analytics pageview per route change. Renders nothing and
 * must sit inside <Router>.
 *
 * The tracker's own automatic pageviews are switched off (data-no-pageview-auto
 * on the tag in public/index.html) because they fired mid-navigation with the
 * previous page's title and missed replaceState entirely — see utils/analytics.js.
 */
const AhrefsPageviews = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackAhrefsPageview();
  }, [pathname, search]);

  return null;
};

export default AhrefsPageviews;
